import { baseApi } from 'api/base';
import { fileApi } from 'api/file';
import { GmpDto, GmpPdf, MovementHistoryItem, MovementRequest } from '../../gmpRegistry/api/params';
import { GmpFormData } from '../types/types';

const MAIN_URL = '/gmp-compliance-conclusions';

const createCard = async (data: GmpFormData): Promise<GmpFormData> => {
  const res = await baseApi.post(MAIN_URL, data);
  return res.data;
};

const getCard = async (id: string): Promise<GmpDto> => {
  const res = await baseApi.get(`${MAIN_URL}/${id}`);
  return res.data;
};

const updateCard = async (data: GmpFormData): Promise<GmpFormData> => {
  const res = await baseApi.put(`${MAIN_URL}`, data);
  return res.data;
};

const getPdf = async (data: GmpPdf) =>
  baseApi
    .post(`${MAIN_URL}/${data.id}/generate-pdf-report`, data, {
      responseType: 'blob',
    })
    .then(fileApi.downloadFile);

const addMovement = async (id: string, data: MovementRequest): Promise<MovementHistoryItem> => {
  const res = await baseApi.post(`${MAIN_URL}/${id}/movement`, data);
  return res.data;
};

const removeMovement = async (id: string, movementId: string): Promise<void> => {
  await baseApi.delete(`${MAIN_URL}/${id}/movement/${movementId}`);
};

export const gmpFormApi = {
  createCard,
  getCard,
  getPdf,
  updateCard,
  addMovement,
  removeMovement,
};
